import { Entity, FieldType, PersistenceType } from 'gossamer-unified';

export interface MetricViewRow {
  seq: number;
  title: string;
  value: number;
}

export const MetricView: Entity<MetricViewRow> = {
  id: 'MetricView',
  title: 'Metric View',
  service: 'main',
  rowLabel: (row: MetricViewRow) => row.title,
  primaryKeyFields: ['seq'],
  source: {
    tableName: 'public.metric_view',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  defaultSort: [['seq', 'ASC']],
  fields: {
    seq: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Seq',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    title: {
      seq: 10,
      type: FieldType.Text,
      label: 'Title',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    value: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Value',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
